import { Directive, ElementRef } from "@angular/core";

@Directive({
    selector: "[acPageTabItem]",
    standalone: false
})
export class PageTabItemDirective {
  constructor(private el: ElementRef) {}

  focus() {
    this.el.nativeElement.focus();
  }
}
